import MacAppStoreBadge from "./images/mac-app-store-badge-black.svg";

const MacAppStore = () => (
  <img src={MacAppStoreBadge} alt="Buy Now on Mac App Store" />
);

export default MacAppStore;
